import Types from '../../reducers/app/types';

export default isOnline => ({
  type: Types.SET_APP_ONLINE_STATE,
  payload: isOnline,
});
